import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { IMG } from "./constants";

export default function Hero({ t }) {
  const stats = [
    { key: "reviews", v: t.hero.stat1, l: t.hero.stat1Label },
    { key: "rating", v: t.hero.stat2, l: t.hero.stat2Label },
    { key: "branches", v: t.hero.stat3, l: t.hero.stat3Label },
  ];

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img src={IMG.heroBg} alt="Bodegón Núñez interior" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/65 to-black/85" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-2 bg-checkered-strong opacity-90" />
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-checkered-strong opacity-90" />

      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-8 py-32 md:py-24 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-script text-2xl md:text-3xl text-bn-accent mb-4"
          data-testid="hero-tagline"
        >
          {t.hero.tagline}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-bn-bg text-5xl sm:text-6xl md:text-8xl lg:text-9xl leading-[0.9] text-shadow-vintage"
          data-testid="hero-title"
        >
          BODEGÓN
          <br />
          NÚÑEZ
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="inline-block mt-6 px-6 py-2 border-y-2 border-bn-accent"
        >
          <p className="font-display text-bn-bg text-xl md:text-2xl tracking-[0.3em]">
            {t.hero.subtitle}
          </p>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.45 }}
          className="mt-8 max-w-2xl mx-auto text-bn-bg/90 text-lg md:text-xl font-body leading-relaxed"
          data-testid="hero-description"
        >
          {t.hero.description}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="#contact"
            data-testid="hero-whatsapp-button"
            className="inline-flex items-center justify-center gap-2 bg-bn-primary hover:bg-bn-primary-dark text-bn-bg px-8 py-4 font-body font-semibold uppercase tracking-wider transition-all hover:-translate-y-0.5"
          >
            {t.hero.cta}
            <ArrowRight size={18} />
          </a>
          <a
            href="#locations"
            data-testid="hero-locations-button"
            className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-bn-bg text-bn-bg hover:bg-bn-bg hover:text-bn-secondary px-8 py-4 font-body font-semibold uppercase tracking-wider transition-all"
          >
            {t.hero.ctaSecondary}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.85 }}
          className="mt-16 grid grid-cols-3 gap-4 md:gap-12 max-w-2xl mx-auto"
        >
          {stats.map((s) => (
            <div key={s.key} className="text-center">
              <div className="font-display text-bn-bg text-2xl md:text-4xl">{s.v}</div>
              <div className="font-body text-bn-bg/70 text-xs md:text-sm uppercase tracking-wider mt-1">
                {s.l}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
